import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Grid from 'material-ui/Grid'
import { FormControl } from 'material-ui/Form'
import Select from 'material-ui/Select'
import Input, { InputLabel } from 'material-ui/Input'
import { MenuItem } from 'material-ui/Menu'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import _ from 'lodash'

import { getPayments, setSearch } from 'modules/users/current/payments'
import paymentsSelector from 'selectors/payments'
import parametersSelector from 'selectors/parameters'

const ProfilePayments = ({ getPayments, setSearch, config_parameters, payments }) => (
  <div style={{ margin: '0 -130px' }}>
    <h2>Payments</h2>
    <Grid container direction="column">
      <Grid container justify="flex-end" item>
        <Grid item md={3} xs={12}>
          <FormControl className="wide">
            <InputLabel htmlFor="payment-type">Select type of payment</InputLabel>
            <Select
              value={payments.search.payment_type || ''}
              onChange={e => {
                setSearch({ payment_type: e.target.value })
                getPayments({ ...payments.search, payment_type: e.target.value })
              }}
              input={<Input id="payment-type" />}
            >
              <MenuItem value="">
                <em>All</em>
              </MenuItem>
              {_.map(payments.filter, (value, key) => (
                <MenuItem key={key} value={key}>
                  {value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      {config_parameters['referral.enabled'] > 0 && (
        <Grid item>
          <ReactTable
            {...payments}
            manual
            onPageChange={page => setSearch({ page })}
            onPageSizeChange={(per_page, page) => setSearch({ per_page, page })}
            onFetchData={state => {
              const { sorted } = state
              const [order] = sorted
              getPayments({
                ...payments.search,
                per_page: state.pageSize,
                page: state.page + 1,
                order_column: order && order.id,
                order_direction: order && (order.desc ? 'desc' : 'asc')
              })
            }}
            className="-striped"
          />
          {payments.total > 0 && (
            <div className="pagination-per-page text-center">
              <br />
              Total <span className="count">{payments.total}</span>
            </div>
          )}
        </Grid>
      )}
    </Grid>
  </div>
)

const mapStateToProps = state => ({
  config_parameters: parametersSelector(state),
  payments: paymentsSelector(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({ getPayments, setSearch }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePayments)



// WEBPACK FOOTER //
// ./src/containers/pages/profile/payments/index.js